var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 73,
    viewBox: "0 0 65 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.65 1H6.95C3.66391 1 1 3.6639 1 6.95V65.8C1 69.0861 3.66391 71.75 6.95 71.75H57.65C60.9361 71.75 63.6 69.0861 63.6 65.8V6.95C63.6 3.6639 60.9361 1 57.65 1Z",
    fill: "url(#paint0_linear_2008_2)",
    stroke: "#186ABC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56982 47.56L18.7098 31.03C18.8096 30.7885 18.9788 30.5821 19.1959 30.4368C19.4131 30.2915 19.6685 30.214 19.9298 30.214C20.1911 30.214 20.4465 30.2915 20.6637 30.4368C20.8809 30.5821 21.0501 30.7885 21.1498 31.03L26.8998 40.4C26.9975 40.6423 27.1653 40.8498 27.3818 40.996C27.5983 41.1421 27.8536 41.2202 28.1148 41.2202C28.376 41.2202 28.6313 41.1421 28.8478 40.996C29.0643 40.8498 29.2322 40.6423 29.3298 40.4L39.1698 24.4C39.2675 24.1577 39.4353 23.9502 39.6519 23.804C39.8684 23.6579 40.1236 23.5798 40.3848 23.5798C40.646 23.5798 40.9013 23.6579 41.1178 23.804C41.3343 23.9502 41.5022 24.1577 41.5998 24.4L56.0398 47.93L8.56982 47.56Z",
    fill: "white",
    stroke: "#0A91D8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7898 28.81C30.5516 28.81 31.9799 27.3818 31.9799 25.62C31.9799 23.8582 30.5516 22.43 28.7898 22.43C27.0281 22.43 25.5999 23.8582 25.5999 25.62C25.5999 27.3818 27.0281 28.81 28.7898 28.81Z",
    fill: "white",
    stroke: "#0896DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2008_2",
    x1: 32.3,
    y1: 1,
    x2: 32.3,
    y2: 71.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A3B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A3E6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group 2.610ca226a4aa85bcb3b81061a02ee3a1.svg";
export { ForwardRef as ReactComponent };